/*
*  Modal for suspending a device
*
* Copyright (C) 2018, 2019 Sterilis Solutions, LLC, all rights reserved.
*/
import React from 'react';
import { withTranslation as translate} from "react-i18next";
import {Button, Header, Modal, TransitionablePortal} from "semantic-ui-react";
import * as Sentry from "@sentry/browser";
import SimpleLoader from "../../SimpleLoader";
import AuthService from "../../AuthService";

const Auth = new AuthService();

class BanDeviceModal extends React.Component {
  state = {
    modalLoading: false,
    allowModalToBeClosed: true,
  };
  banDevice = () => {
    const {
      modalDeviceID,
      modalSerial
    } = this.props;
    this.setState({
      modalLoading: true,
      allowModalToBeClosed: false,
    });

    Auth.fetch(`/api/device/${modalDeviceID}/`, {
      method: 'PATCH',
      body: JSON.stringify({
        banned: true
      })
    }).then(data => {
      this.setState({
        modalLoading: false,
        allowModalToBeClosed: true,
      }, () => {
        this.props.preparePage(this.props.prepareParameter);
        this.props.triggerBanDeviceModal(null);
        this.props.notifySuccess('suspended', 'device', modalSerial)
      });
    }).catch(err => {
      Sentry.captureException(err);
      this.setState({
        modalLoading: false,
        allowModalToBeClosed: true,
      }, () => {
        this.props.triggerBanDeviceModal(null);
        this.props.notifyFailure()
      });
    });
  };

  render() {
    const {
      t
    } = this.props;
    const {
      modalLoading
    } = this.state;

    const inlineStyle = {
      modal: {
        // marginTop: topMargin,
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      textArea: {
        marginTop: '50px',
        width: '400px'
      }
    };
    return (
      <TransitionablePortal
        open={this.props.showBanDeviceModal}
        onOpen={() => setTimeout(() => document.body.classList.add('modal-fade-in'), 0)}
        transition={{animation: 'scale', duration: 500}}
      >
        <Modal
          style={inlineStyle.modal}
          open={true}
          closeOnDimmerClick={this.state.allowModalToBeClosed}
          closeIcon={<Button className='close-modal-btn grey-btn'>{t('Close')}</Button>}
          size='small'
          onClose={(event) => {
            document.body.classList.remove('modal-fade-in');
            this.props.triggerBanDeviceModal(null)
          }}
        >
          <Header>
            <h2 className='red-text'>{t('Suspend Device')}</h2>
          </Header>
          {modalLoading ? (
            <SimpleLoader/>
          ) : null}
          <Modal.Content>
            <div className='short-modal-text center-text'>
              <p>Are you sure you want to suspend <strong>{this.props.modalSerial}</strong>?</p>
              <p>The device will no longer be able to communicate with the portal.</p>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button className='red-btn'
                    value="Submit"
                    type="submit"
                    id='banDeviceBtn'
                    onClick={this.banDevice}
            >{t('Suspend Device')}</Button>
          </Modal.Actions>
        </Modal>
      </TransitionablePortal>
    )
  }
}

export default translate('translations')(BanDeviceModal);
